import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {API_URL} from "../../constants";
import {checkResponse} from "../../utils";
import {Categories, ItemType, ShopData, ShopState} from "../../entity/index.entity";
import {AppDispatch} from "../../index";

export const fetchShopItemsAll = createAsyncThunk<ShopData, void, { dispatch: AppDispatch }>(
    'shop/fetchItemsAll',
    async (_, {dispatch, rejectWithValue}) => {
        const res = await fetch(`${API_URL}/shop/`);
        const itemsList = await checkResponse(res);
        return itemsList;
    }
);
export const fetchShopCategories = createAsyncThunk<Categories[], void, { dispatch: AppDispatch }>(
    'shop/fetchCategories',
    async (_, {dispatch, rejectWithValue}) => {
        const res = await fetch(`${API_URL}/categories/`);
        const categoriesList = await checkResponse(res);
        return categoriesList;
    }
);

export const fetchShopItemsByCategory = createAsyncThunk(
    'shop/fetchShopItemsByCategory',
    async (category: string) => {
        const res = await fetch(`${API_URL}/shop/?category=${category}`);
        const categories = await checkResponse(res);
        return categories;
    }
);

export const fetchShopItem = createAsyncThunk(
    'shop/fetchShopItem',
    async (id: string) => {
        const res = await fetch(`${API_URL}/shop/${id}`);
        const item = await checkResponse(res);
        return item;
    }
);

const ShopSlice = createSlice({
    name: 'shopSlice',
    initialState: {
        items: [] as ItemType[],
        mainPageImage: null,
        shopCategories: [] as Categories[],
        item: null as ItemType | null
    } as ShopState,
    reducers: {
        clearItem: (state) => {
            state.item = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchShopItemsAll.fulfilled, (state, action) => {
                state.items = action.payload.items;
                state.mainPageImage = action.payload.main_page_image;
            })
            .addCase(fetchShopCategories.fulfilled, (state, action) => {
                state.shopCategories = action.payload;
            })
            .addCase(fetchShopItemsByCategory.fulfilled, (state, action) => {
                state.items = action.payload.items;
                state.mainPageImage = action.payload.main_page_image;
            })
            .addCase(fetchShopItem.fulfilled, (state, action) => {
                state.item = action.payload;
            });

    }
});

export const {
    clearItem
} = ShopSlice.actions;
export default ShopSlice.reducer;